<template>
  <nav class="navbar is-fixed-top is-spaced" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/hvclogo.png?alt=media">
      </a>

      <a role="button" class="navbar-burger is-hidden-touch" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-end">
        <a class="navbar-item" href="/"><strong>Home</strong></a>
        <a class="navbar-item" href="/#about"><strong>About</strong></a>
        <a class="navbar-item" href="/#arts"><strong>Arts</strong></a>
        <a class="navbar-item" href="/#contact"><strong>Contact</strong></a>
        <a class="button is-primary is-rounded" @click="goToShop"><strong>Online Shop</strong></a>

        <!-- <a class="button is-primary is-rounded" @click="goToPanningTour"><strong>Gold Panning Tours</strong></a> -->
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  methods: {
    goToHolidayPage() {
      this.$router.push('/holiday').catch({});
    },
    goToPanningTour() {
      window.open("https://www.viator.com/tours/Kelowna-and-Okanagan-Valley/The-Best-Gold-Panning-at-Mission-Creek/d22366-418211P1?mcid=61846", '_blank');
    },
    goToShop() {
      window.open("https://shop.hiddenvillagecreations.com/", '_blank');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

  // Transition effect for navbar
  $(window).scroll(function() {
    // checks if window is scrolled more than 500px, adds/removes solid class
    if($(document).scrollTop() > 500) {
        $('.navbar').addClass('solid');
    } else {
        $('.navbar').removeClass('solid');
    }
  });

});
</script>

<style>
.navbar.solid {
  background-color: #000000;
}
</style>
